import React, { createElement, Component } from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
// ── Helpers ───────────────────────────────────────────────────────────────────
function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
}
function setCookie(name: string, value: string, maxAge: number) {
  document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; SameSite=Lax`;
}
// ── Variant assignment ────────────────────────────────────────────────────────
const isLive = window.location.hostname.endsWith('legendaryreads.com');
const isV2Path = window.location.pathname.startsWith('/v2');
const isV3Path = window.location.pathname.startsWith('/v3');
const isV4Path = window.location.pathname.startsWith('/v4');
const isV5Path = window.location.pathname.startsWith('/v5');
const isV6Path = window.location.pathname.startsWith('/v6');
const isVIntPath = window.location.pathname.startsWith('/vint');
// Valid split-test variants for the 2-way test (V4 vs V6, 50/50)
const SPLIT_VARIANTS = ['V4', 'V6'] as const;
type SplitVariant = (typeof SPLIT_VARIANTS)[number];
function isValidSplitVariant(v: string): v is SplitVariant {
  return SPLIT_VARIANTS.includes(v as SplitVariant);
}
function assignRandomVariant(): SplitVariant {
  return Math.random() < 0.5 ? 'V4' : 'V6';
}
let variant: string;
let reason: string;
if (isVIntPath) {
  variant = 'D_VINT';
  reason = 'forced_by_path_vint';
} else if (isV6Path) {
  variant = 'D_V6';
  reason = 'forced_by_path_v6';
} else if (isV5Path) {
  variant = 'D_V5';
  reason = 'forced_by_path_v5';
} else if (isV4Path) {
  variant = 'D_V4';
  reason = 'forced_by_path_v4';
} else if (isV3Path) {
  variant = 'D_V3';
  reason = 'forced_by_path_v3';
} else if (isV2Path) {
  variant = 'D_V2';
  reason = 'forced_by_path_v2';
} else if (!isLive) {
  // Preview: / always shows VINT02
  variant = 'VINT02';
  reason = 'preview_forced';
} else {
  // Live + / path: 100% traffic to VINT02
  variant = 'VINT02';
  reason = 'assigned_vint02';
}
// Expose globally so App.tsx can read it without re-parsing cookie
;
(window as any).__abVariant = variant;
// Debug log (temporary — remove after validation)
console.log('AB variant:', variant, '| reason:', reason, '| host:', window.location.hostname, '| path:', window.location.pathname);
// ── Render app ────────────────────────────────────────────────────────────────
render(<AppRouter data-id="element-701" />, document.getElementById('root'));
(() => {
  if ((window as any).__meta_pixel_loaded) return;
  (window as any).__meta_pixel_loaded = true;
  const f = window as any;
  if (f.fbq) return;
  const n: any = f.fbq = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(s);
  f.fbq('init', '1847761419278798');
  // New pixel for root and /vint02 only
  const path = window.location.pathname;
  if (path === '/' || path.startsWith('/vint02')) {
    f.fbq('init', '924389260192791');
  }
  f.fbq('track', 'PageView');
  f.fbq('track', 'ViewContent');
})();
(() => {
  if ((window as any).__clarity_loaded) return;
  (window as any).__clarity_loaded = true;
  const f = window as any;
  const n: any = f.clarity = function (...args: any[]) {
    n.q = n.q || [];
    n.q.push(args);
  };
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://www.clarity.ms/tag/vn5x9ewnu9';
  document.head.appendChild(s);
})();
(() => {
  if ((window as any).__cs_loaded) return;
  (window as any).__cs_loaded = true;
  const s = document.createElement('script');
  s.src = 'https://t.contentsquare.net/uxa/dc0bea528efc9.js';
  s.async = true;
  document.head.appendChild(s);
})();
(() => {
  if ((window as any).__clickflare_loaded) return;
  (window as any).__clickflare_loaded = true;
  const s = document.createElement('script');
  s.textContent = `!function(){"use strict";var n="lp_ref",t="cpid",e="lpurl",c="https://library.legendaryreads.com",r="(?<domain>http(?:s?)://[^/]*)".concat("/cf/click"),a="(?:(?:/(?<cta>[1-9][0-9]*)/?)|(?:/))?",i="^".concat(r).concat(a).concat("(?:$|(\\\\?.*))"),o='javascript:window.clickflare.l="(?<original_link>'.concat(r).concat(a,'("|(\\\\?[^"]*"))).*'),s=function(){return new RegExp(i,"")},u=function(){return new RegExp(o,"")};function l(n){var t=function(n){return n.replace(s(),(function(n){for(var t=[],e=1;e<arguments.length;e++)t[e-1]=arguments[e];var r=t[t.length-1].domain;return n.replace(r,c)}))}(n);return'javascript:window.clickflare.l="'.concat(t,'"; void 0;')}function d(n,t){if(t&&n&&t.apply(document,[n]),/loaded|interactive|complete/.test(document.readyState))for(var e=0,c=document.links.length;e<c;e++)if(s().test(document.links[e].href)){var r=document.links[e];window.clickflare.links_replaced.has(r)||(r.href=l(r.href),window.clickflare.links_replaced.add(r))}}var f,h,m,p;!function(r,a){var i=document.onreadystatechange;window.clickflare||(window.clickflare={listeners:{},customParams:{},links_replaced:new Set,addEventListener:function(n,t){var e=this.listeners[n]||[];e.includes(t)||e.push(t),this.listeners[n]=e},dispatchEvent:function(n,t){t&&(this.customParams[n]=t),(this.listeners[n]||[]).forEach((function(n){return n(t)}))},push:function(n,t){t&&(this.customParams[n]=t),(this.listeners[n]||[]).forEach((function(n){return n(t)}))}},document.onreadystatechange=function(n){return d(n,i)},d(null,i),setTimeout((function(){!function(r,a){var i,o=function(r,a){var i=new URL("".concat(c).concat(r)),o="{",s=o+o;a.startsWith(s)||i.searchParams.set(t,a);return i.searchParams.append(n,document.referrer),i.searchParams.append(e,location.href),i.searchParams.append("lpt",document.title),i.searchParams.append("t",(new Date).getTime().toString()),i.toString()}(r,a),s=document.createElement("script"),l=document.scripts[0];s.async=1,s.src=o,s.onerror=function(){!function(){for(var n=function(n,t){var e=document.links[n];u().test(decodeURI(e.href))&&setTimeout((function(){e&&e.setAttribute("href",function(n){var t=n.match(u());if(t){var e=(t.groups||{}).original_link;return e?e.slice(0,-1):n}return n}(decodeURI(e.href)))}))},t=0,e=document.links.length;t<e;t++)n(t)}()},null===(i=l.parentNode)||void 0===i||i.insertBefore(s,l)}(r,a)})))}("".concat("/cf/tags","/").concat(new URL(window.location.href).searchParams.get("cftmid")||"{{__CONTAINER_ID__}}"),(m=new URL(window.location.href).searchParams.get(t),f=new RegExp("(^| )".concat("cf_cpid","=([^;]+)")),p=(h=document.cookie.match(f))&&h.pop()||null,m||p||"69bd7f44bec12a0012147a5a"))}();`;
  document.body.appendChild(s);
})();
(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const clickId = urlParams.get('click_id') || sessionStorage.getItem('cf_click_id');
  if (!clickId) return;
  if (sessionStorage.getItem('pricing_section_viewed')) return;
  let fired = false;
  const tryObserve = () => {
    const el = document.getElementById('pricing-top') || document.getElementById('pricing-section');
    if (!el) return;
    clearInterval(poll);
    const io = new IntersectionObserver(entries => {
      if (fired) return;
      for (const entry of entries) {
        if (entry.isIntersecting) {
          fired = true;
          sessionStorage.setItem('pricing_section_viewed', 'true');
          io.disconnect();
          const img = new Image();
          img.src = `https://library.legendaryreads.com/cf/cv?click_id=${encodeURIComponent(clickId)}&ct=pricing_section`;
          console.log('[ClickFlare] Pricing section postback fired', clickId);
          break;
        }
      }
    }, {
      threshold: 0.1
    });
    io.observe(el);
  };
  const poll = setInterval(tryObserve, 500);
  tryObserve();
})();